export const GAME_MESSAGE_CODES = {
	game: {
		error: "E_GAMING",
		notFound: "E_GAMING_GAMENOTFOUND",
		notFoundForDevice: "E_GAMING_GAMENOTFOUNDFORCURRENTDEVICE",
		misConfigured: "E_GAMING_GAMEMISCONFIGURED",
		productNotAllowed: "E_GAMING_PRODUCTNOTALLOWEDFORCUSTOMER",
		gameplayNotAllowed: "E_GAMING_GAMEPLAYNOTALLOWEDFORCUSTOMER",
	},
	gamePlay: {
		gameNotAvailbleForFun: "E_GAMING_GAMENOTAVAILABLEFORFUN",
		gameNotAvailableForDevice: "E_GAMING_GAMENOTAVAILABLEFORCURRENTDEVICE",
		gameNotAvailableForCustomer: "E_GAMING_GAMENOTAVAILABLEFORCUSTOMER",
		gamePlayNotAllowedForCustomer: "E_GAMING_GAMEPLAYNOTALLOWEDFORCUSTOMER",
		providerNotAvailableForCustomer: "E_GAMING_GAMEPROVIDERNOTAVAILABLEFORCUSTOMER",
	},
	provider: {
		notFound: "E_GAMING_GAMEPROVIDERNOTFOUND",
	},
	providerAccount: {
		notFound: "E_GAMING_GAMEPROVIDERACCOUNTS_PROVIDER_ACCOUNTNOTFOUND",
		error: "E_GAMING_GAMEPROVIDERACCOUNTS_PROVIDER",
	},
	favouriteGames: {
		alreadyExists: "E_GAMING_FAVOURITEGAMEALREADYEXISTS",
		addSuccess: "M_ADD_FAVOURITE_SUCCESS",
		removeSuccess: "M_REMOVE_FAVOURITE_SUCCESS",
	},
	metatag: {
		error: "E_GAMING_METATAGS",
		notFound: "E_GAMING_METATAGS_METATAGNOTFOUND",
	},
	playLimit: {
		success: "PLAYLIMIT_SUCCESS",
		error: "E_PLAYLIMIT_CONFLICT",
	},
};
